import React from 'react'
import Page from 'components/Page/Page'
import Table from 'components/Display/Table/Table'
import {
    useCreateAccountReportMutation,
    useDeleteAccountReportMutation,
    useGetAccountReportsQuery,
} from 'store/Store'

const AccountReport = () => {
    return (
        <Page>
            <Table
                itemName="account_report"
                paginationType="external"
                allowDelete
                allowEdit
                allowCreate
                allowExpanded
                useEditMutation={useCreateAccountReportMutation}
                useGetQuery={useGetAccountReportsQuery}
                useCreateMutation={useCreateAccountReportMutation}
                useDeleteMutation={useDeleteAccountReportMutation}
            />
        </Page>
    )
}

export default AccountReport
